<script>
import humanizeDuration from "humanize-duration";
import "../boxplot";
import { asBoxPlotStats } from "../boxplot/data";
import { generateChart } from "vue-chartjs";
import { companyDSARTimeBoxPlot } from "../../../../api/charts";
import { colors, plugins } from "../commons";

const BoxPlotVue = generateChart("dsar-time-boxplot", "boxplot");

export default {
  extends: BoxPlotVue,
  props: {
    company: {
      type: Number,
      default: null,
    },
  },

  async mounted() {
    this.addPlugin(plugins.noData);

    const response = await companyDSARTimeBoxPlot(this.company);
    const data = response.data;

    const values = [];

    for (const item of data) {
      values.push(item.time);
    }

    const datasets = [];
    const bpStats = [];
    const hcfg = { language: "pt", largest: 3 };

    if (values.length) {
      const dataColors = colors.default();
      const color = dataColors[0];
      datasets.push({
        backgroundColor: color,
        borderColor: colors.darken(color),
        borderWidth: 1,
        outlierColor: "#dd0080",
        meanColor: "#ff8b14",
        padding: 10,
        itemRadius: 0,
        data: [values],
      });

      const bp = asBoxPlotStats(values);
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      const mean = values.reduce(reducer) / values.length;
      bpStats.push(
        "",
        `Mínimo: ${humanizeDuration(bp.min, hcfg)}`,
        `Médio: ${humanizeDuration(mean, hcfg)}`,
        `Máximo: ${humanizeDuration(bp.max, hcfg)}`,
        ""
      );
    }

    this.renderChart(
      { datasets },
      {
        title: {
          text: ["Tempo de processamento", ...bpStats],
          display: true,
        },
        legend: {
          display: !this.company,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value /*, index, values*/) {
                  return humanizeDuration(value, hcfg);
                },
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
        },
      }
    );
  },
};
</script>
